let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9EQz0")).then(() => parcelRequire('8hfZh'));